import { TextField } from "@mui/material";

const ChangePasswordForm = ({values, errors, handleChange}) => {
  return (
      <TextField
        label="New Password"
        fullWidth
        onChange={handleChange}
        value={values.new_password}
        name="new_password"
        error={Boolean(errors.new_password)}
        helperText={errors.new_password}
        sx={{ my: '0.5rem' }}
      />
  );
};

export default ChangePasswordForm;
